module.exports = __webpack_public_path__ + "img/组 130@2x(1).1f0f6a6e.png";